<template>
    <div class="w-100">
        <div class="map-item-filter">
            <div
                class="col-sm-12 nopads vehicle-list"
                :class="{ list_closed: !listOpen }"
            >
                <span
                    class="vehicle-list-title"
                    @click.stop="toggleList"
                >Harja</span>
                <div
                    class="vehicle-list-caret"
                    :class="{ caret_open: listOpen }"
                    @click.stop="toggleList"
                >
                    <font-awesome-icon icon="caret-down" />
                </div>
                <div
                    v-if="listOpen"
                    class="col-sm-12 nopads vehicle-list-container"
                >
                    <div class="p-2">
                        <form
                            @submit.prevent="fetchHarjaNotifications"
                            @reset="onReset"
                        >
                            <div class="d-flex gap-2 mb-2">
                                <div class="flex-fill">
                                    <span class="form-check-label text-light">{{ $t('delivery_note.date') }} - {{ $t('trip_list.road_sec_from') }}</span>
                                    <date-time-picker
                                        v-model:date="startDate"
                                        response-type="date"
                                        class="routa-input"
                                    />
                                </div>
                                <div class="flex-fill">
                                    <span class="form-check-label text-light">{{ $t('delivery_note.date') }} - {{ $t('trip_list.road_sec_to') }}</span>
                                    <date-time-picker
                                        v-model:date="endDate"
                                        response-type="date"
                                        class="routa-input"
                                    />
                                </div>
                            </div>
                            <div class="d-flex gap-2 mb-2">
                                <div style="flex: 1">
                                    <span class="form-check-label text-light">{{ $t('harja.status') }}</span>
                                    <select
                                        v-model="state"
                                        class="form-control form-select form-select-sm"
                                    >
                                        <option
                                            v-for="opt in stateOptions"
                                            :key="opt.value"
                                            :value="opt.value"
                                        >
                                            {{ $t(opt.label) }}
                                        </option>
                                    </select>
                                </div>
                                <div style="flex: 1">
                                    <span class="form-check-label text-light">{{ $t('harja.notification_type') }}</span>
                                    <select
                                        v-model="messageType"
                                        class="form-control form-select form-select-sm"
                                    >
                                        <option
                                            v-for="opt in messageTypeOptions"
                                            :key="opt.value"
                                            :value="opt.value"
                                        >
                                            {{ $t(opt.label) }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                            <div class="button-container">
                                <button
                                    type="submit"
                                    class="btn btn-primary form-button"
                                >
                                    {{ $t('ins_report.search') }}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
        <harja-notification-modal
            v-if="editHarja"
            v-model="editHarja"
            style="pointer-events: all"
            @cancel="editHarja = null"
        />
        <div
            v-if="loading"
            id="loader"
            class="spinner"
        />
    </div>
</template>

<script>
import {mapHelper} from '@/components/mixins/MapMixin'
import {restApi} from '@/components/mixins/RestApiMixin'
import {timeUtils} from '@/components/mixins/TimeUtils'
import harjaNotificationModal from '@/components/velho/HarjaNotificationModal'
import DateTimePicker from '@/components/common/DateTimePicker'

export default {
    name: 'HarjaMap',
    components: {harjaNotificationModal, DateTimePicker},
    mixins: [mapHelper, restApi, timeUtils],
    props: {
        map: {type: Object, default: null},
        boundingBox: {type: Array, default: () => []},
        selectedContract: {type: Object, default: null}
    },
    data() {
        return {
            listOpen: false,
            searchResults: null,
            editHarja: null,
            loading: false,
            startDate: null,
            endDate: null,
            startParam: null,
            endParam: null,
            state: '',
            messageType: 'toimenpidepyynto',
            stateOptions: [
                { value: '', label: this.$t("harja.all") },
                { value: 'lopetettu', label: this.$t("harja.closed") },
                { value: 'vastaanotettu', label: this.$t("harja.received") },
                { value: 'kuittaamaton', label: this.$t("harja.unacknowledged") }
            ],
            messageTypeOptions: [
                { value: '', label: this.$t("harja.all") },
                { value: 'tiedoitus', label: this.$t("harja.notification") },
                { value: 'toimenpidepyynto', label: this.$t("harja.action_request") }
            ]
        }
    },
    watch: {
        endDate() {
            if (this.endDate) {
                const date = new Date(this.endDate)
                const year = date.getFullYear()
                const month = String(date.getMonth() + 1).padStart(2, '0')
                const day = String(date.getDate()).padStart(2, '0')
                this.endParam = `${year}-${month}-${day}T23:59:59+03`
            }
        },
        startDate() {
            if (this.startDate) {
                const date = new Date(this.startDate)
                const year = date.getFullYear()
                const month = String(date.getMonth() + 1).padStart(2, '0')
                const day = String(date.getDate()).padStart(2, '0')
                this.startParam = `${year}-${month}-${day}T00:00:00+03`
            }
        }
    },
    mounted() {
        this.startDate = this.getMonthStart()
        this.endDate = this.getToday()
    },
    beforeUnmount() {
        this.hideMarkers()
    },
    methods: {
        toggleList() {
            this.listOpen = !this.listOpen
        },
        onReset() {
            this.startDate = this.getMonthStart()
            this.endDate = this.getEndOfTheDay(new Date())
        },
        async fetchHarjaNotifications() {
            let params = {}
            params.start_date = this.startParam
            params.end_date = this.endParam
            if (this.selectedContract?.id) {
                params.contract = this.selectedContract.id
            }
            if (this.state) {
                params.status = this.state
            }
            if (this.messageType) {
                params.notification_type = this.messageType
            }
            try {
                this.loading = true
                this.restFetchParams(this.harjaAlertUrl, params, this.fetchSuccess, this.fetchFailed)
            } catch (e) {
                this.loading = false
            }
        },
        fetchSuccess(response) {
            this.loading = false
            this.handleSearch(response.data)
        },
        fetchFailed() {
            this.loading = false
        },
        onMarkerTap(data) {
            if (this.searchResults) {
                const result = this.searchResults.find(r => r.ilmoitus && r.ilmoitus.ilmoitusid === data.id)
                if (result) {
                    this.editHarja = result.ilmoitus
                }
            }
        },
        handleSearch(data) {
            this.hideMarkers()
            this.searchResults = data
            this.showMarkers()
        },
        showMarkers() {
            if (!this.searchResults || !this.map) return
            this.searchResults.forEach((result, index) => {
                if (result && result.ilmoitus && result.ilmoitus.sijainti) {
                    let harjaLocation = result.ilmoitus.sijainti
                    this.map.showMapMarker(result.ilmoitus.ilmoitusid, this.HARJA_MESSAGES, harjaLocation.koordinaatit.y,
                        harjaLocation.koordinaatit.x, this.map.getMarkerStore().getHarjaNotificationMarkerIcon())
                }
            })
        },
        hideMarkers() {
            if (this.map) {
                this.map.removeMapMarkerByType(this.HARJA_MESSAGES)
            }
        }
    }
}
</script>
